import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { IdGenerator } from "../../rxjs/configureEpics"
import type { AssignmentFormItem } from "./AssignmentForm"
import type { Assignment } from "../../../graphql/types"

export const dataLengthChanged = (previousData: Assignment[], nextData: Assignment[]) => {
    if (nextData.length !== previousData.length) {
        return true
    }

    return nextData.some(el => {
        const prevDataEl = previousData.find(pEl => pEl.id === el.id)

        if (prevDataEl) {
            if ((!prevDataEl.children && el.children) || (prevDataEl.children && !el.children)) {
                return true
            }

            if (prevDataEl.children && el.children) {
                return prevDataEl.children.length !== el.children.length
            }
        }

        return false
    })
}

export const composeAssignment = (
    formItem: AssignmentFormItem,
    sortIndex: Maybe<number>,
    idgen: IdGenerator
): Partial<Assignment> => {
    const assignmentId = formItem.assignmentId || idgen.next()
    return {
        id: assignmentId,
        name: formItem.name,
        // @ts-expect-error
        locationId: formItem.locationId,
        showAsQuickFilter: formItem.showAsQuickFilter === undefined ? false : formItem.showAsQuickFilter,
        config: formItem.config,
        parentId: formItem.parentId,
        ...(sortIndex != null
            ? {
                  sortIndex: sortIndex,
              }
            : null),
    }
}

export const getHighestSortIndex = (assignments: Assignment[], parentId: Maybe<string>) => {
    const sameParentAssignments = assignments.filter(a => a.parentId === parentId).map(a => a.sortIndex)
    return sameParentAssignments.length > 0 ? Math.max(...sameParentAssignments) : 0
}

export const getLowestSortIndex = (assignments: Assignment[], parentId: Maybe<string>) => {
    const sameParentAssignments = assignments.filter(a => a.parentId === parentId).map(a => a.sortIndex)
    return sameParentAssignments.length > 0 ? Math.min(...sameParentAssignments) : 0
}
